import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import ProvinceCityCard from './ProvinceCityCard';
import SearchInMap from '@/common/components/business/SearchInMap';
import { getStorage, setStorage } from '@lhb/cache';
import { networkMapContainer, sectionKey } from '../SiteView/ts-config';
import ToolBox from '@/common/components/AMap/components/ToolBox';
import IconFont from '@/common/components/IconFont';
import { addBusiness, levelEnum, mapCon } from '../../ts-config';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { message } from 'antd';
import cs from 'classnames';

const siteSelectionMapBHistorySearchList = 'lcnSiteSelectionMapBHistorySearchList';

/**
 * @Description 顶部
 */
const AllLevelTop:FC<{
  viewLevel,
  setViewLevel,
  setChecked,
  mapIns,
  mapHelpfulInfo,
  setPoiData,
  curSelectDistrict,
  setCurSelectDistrict,
  isShape,
  setIsShape,
  isGreater1440,
  isGreater1920
}> = ({
  viewLevel,
  setViewLevel,
  setChecked,
  mapIns,
  mapHelpfulInfo,
  setPoiData,
  curSelectDistrict,
  setCurSelectDistrict,
  isShape,
  setIsShape,
  isGreater1440,
  isGreater1920
}) => {
  const toolBoxRef = useRef<any>(null);// 工具箱ref
  const historySearchListRef = useRef<any[]>(getStorage(siteSelectionMapBHistorySearchList) || []);

  const [isSelectToolBox, setIsSelectToolBox] = useState<boolean>(false);// 工具箱内部按钮是否激活


  const finallySelected = (target: any) => {
    if (!target) return;
    const { extraData } = target || {};
    setPoiData(extraData);

    if (target) {
      // 缓存历史搜索结果
      cacheSearchList(extraData);
      handleSelectDistrict(extraData);
    }
  };
  // 缓存历史搜索结果
  const cacheSearchList = (extraData) => {
    const oldData = historySearchListRef.current;
    // historySearchListRef.current = [extraData, ...oldData];
    // 根据经纬度去重
    const coordinates = {};
    historySearchListRef.current = [extraData, ...oldData].filter(item => {
      const key = `${item.latitude}-${item.longitude}`;
      if (!coordinates[key]) {
        coordinates[key] = true;
        return true;
      }
      return false;
    });
    const newData = historySearchListRef.current.filter((item, index) => index < 4);
    historySearchListRef.current = newData;
    // 最多缓存五条历史记录
    setStorage(siteSelectionMapBHistorySearchList, newData);
  };

  // 搜索地址和行政区条件筛选联动（ui要求）
  // 1.当搜索地址和条件筛选已选行政区一致，则不做变动
  // 2.当搜索地址和条件筛选已选行政区不一致但在同一个城市，则行政区取消已选中
  // 3.当搜索地址和条件筛选已选行政区不一致且不在一个城市，则行政区取消已选中
  const handleSelectDistrict = (extraData) => {

    const curCityId = curSelectDistrict?.cacheMapInfo?.city?.id;
    // 未选择行政区，所以不会进行下面的操作
    if (!curCityId) return;
    const districtCodeList = curSelectDistrict?.districtInfo?.map((item) => {
      return +item.code;
    });
    const { cityId, districtId } = extraData;

    if (districtCodeList.includes(+districtId)) return;// 符合条件1
    // 符合条件2（行政区id不一致）||符合条件3（城市id不一致）
    if (!districtCodeList.includes(+districtId) || curCityId !== cityId) {
      // 清空
      setChecked((state) => ({
        ...state,
        [sectionKey.area]: []
      }));
      setCurSelectDistrict({
        districtInfo: [], // 当前选中的行政区信息
        cacheMapInfo: null, // 缓存选中行政区信息时的mapHelpfulInfo
      });
    }
  };
  const keywordChange = (str: string) => {
    if (!str) {
      setPoiData(null);
    }
  };

  // 处理绘制商圈中禁止点击其他操作
  const handlePreventdefault = (e) => {
    const mapDom:any = document.querySelector(`.${mapCon}`);
    const addBusinessBtn:any = document.querySelectorAll(`.${addBusiness}`);
    let flag = false;
    addBusinessBtn.forEach((doc) => {
      if (doc?.contains(e.target)) {
        flag = true;
      }
    });

    if (!mapDom.contains(e.target) && !flag) {
      V2Message.warning(`请先完成新增开店区域信息填写或删除该开店区域`);
      message.config({ maxCount: 1 });
      e.preventDefault();
      e.stopPropagation();
      e.target.blur();

    }
  };
    // 处理绘制商圈中禁止点击其他操作
  useEffect(() => {
    const dom:any = document.querySelector(`.${networkMapContainer}`);

    if (isShape) {
      // 除地图元素和新增商圈外
      dom.addEventListener('click', handlePreventdefault);
      // 禁止键盘操作，快速上下左右操作会导致地图白掉
      mapIns?.setStatus({ keyboardEnable: false });
    } else {
      // 禁止键盘操作，快速上下左右操作会导致地图白掉
      mapIns?.setStatus({ keyboardEnable: true });
    }
    return () => {
      dom.removeEventListener('click', handlePreventdefault);
    };
  }, [isShape]);

  return <div className={styles.topCon}>
    {/* 省市名称卡片 */}
    <ProvinceCityCard
      viewLevel={viewLevel}
      setViewLevel={setViewLevel}
      isGreater1440={isGreater1440}
      isGreater1920={isGreater1920}
    />

    {/* 搜索、工具箱、新增商圈 -- 选址视角下才会有*/}
    {viewLevel.level === levelEnum.site
      ? <div className={cs(styles.topCenter, addBusiness)}>
        {/* 搜索 */}
        <span>
          <SearchInMap
            mapIns={mapIns}
            mapHelpfulInfo={mapHelpfulInfo}
            finallySelected={finallySelected}
            isMock={false}
            historySearchList={historySearchListRef.current}
            finallyKeywords={(str) => {
              keywordChange(str);
            }}
            hideBorder
            autoCompleteConfig={{
              style: {
                marginRight: 12
              }
            }}
            searchConfig={{
              style: {
                width: 280,
                height: 36
              },
            }}
            panToLocation={false}
            zoomToAccuracy={false}
          />
        </span>
        {/* 工具箱 */}
        <span>
          <ToolBox
            _mapIns={mapIns}
            level={mapHelpfulInfo?.level}
            city={mapHelpfulInfo?.city}
            heartMap={false}
            beforeIcon={<IconFont iconHref='iconic_toolbox' className='fs-16'/>}
            afterIcon={<IconFont
              style={{ position: 'absolute', right: 12, top: 11, }}
              iconHref='pc-common-icon-a-iconarrow_down'/>}
            toolBoxWrapperStyle={{
              height: '36px',
              lineHeight: '36px',
              width: 145
            }}
            // satellite={false}
            isCheckInsideMapOperate={isSelectToolBox}
            setIsCheckInsideMapOperate={setIsSelectToolBox}
            isCheckOutsideMapOperate={isShape}
            setIsCheckOutsideMapOperate={setIsShape}
            getAddressEventId='77d90423-f1e3-435b-ae6c-496799735a25'
            rulerEventId='6747d0f9-52c0-46fd-80e9-15aa432027b8'
            satelliteEventId='78001ba5-13c9-4f73-86dd-1da5d23063b2'
            contentStyle={{
              width: 145
            }}
            ref={toolBoxRef}
          />
        </span>
      </div>
      : <></>}

  </div>;
};
export default AllLevelTop;

